import React from 'react';
import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { goToSubstep } from 'registration/creative/ducks';
import { updateMobilePhone, verifyPhoneByCode } from 'common/ducks/user';
import Substep2_2 from 'registration/creative/components/substep2_2';

const mapStateToProps = ({
  user, creativeRegistration: { idValidated, reviewing, resumedFromMagicLink }
}) => ({
  user,
  reviewing,
  resumedFromMagicLink,
  idValidated
})

export default connect(mapStateToProps, {
  updateMobilePhone,
  verifyPhoneByCode,
  nextSubstep: partial(goToSubstep, 'profile')
})(Substep2_2);



// WEBPACK FOOTER //
// ./registration/creative/containers/substep2_2.jsx